import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PathLocationStrategy, LocationStrategy, HashLocationStrategy} from '@angular/common';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('app/content/pages/pages.module').then(m => m.PagesModule)
	},
	{
		path: '**',
		redirectTo: '404',
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule],
	providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class AppRoutingModule {}
